var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentHiring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22.5H6V20.25H3V22.5H1.5V20.25C1.5 19.4227 2.17275 18.75 3 18.75H6C6.82725 18.75 7.5 19.4227 7.5 20.25V22.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.5H21V20.25H18V22.5H16.5V20.25C16.5 19.4227 17.1727 18.75 18 18.75H21C21.8273 18.75 22.5 19.4227 22.5 20.25V22.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5H13.5V20.25H10.5V22.5H9V20.25C9 19.4227 9.67275 18.75 10.5 18.75H13.5C14.3273 18.75 15 19.4227 15 20.25V22.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.5C13.5 15.6712 12.8288 15 12 15C11.1712 15 10.5 15.6712 10.5 16.5C10.5 17.3288 11.1712 18 12 18C12.8288 18 13.5 17.3288 13.5 16.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.5C6 15.6712 5.32875 15 4.5 15C3.67125 15 3 15.6712 3 16.5C3 17.3288 3.67125 18 4.5 18C5.32875 18 6 17.3288 6 16.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.5C21 15.6712 20.3288 15 19.5 15C18.6712 15 18 15.6712 18 16.5C18 17.3288 18.6712 18 19.5 18C20.3288 18 21 17.3288 21 16.5Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 13.5C17.25 12.6712 16.5788 12 15.75 12C14.9212 12 14.25 12.6712 14.25 13.5C14.25 14.3288 14.9212 15 15.75 15C16.5788 15 17.25 14.3288 17.25 13.5Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 13.5C9.75 12.6712 9.07875 12 8.25 12C7.42125 12 6.75 12.6712 6.75 13.5C6.75 14.3288 7.42125 15 8.25 15C9.07875 15 9.75 14.3288 9.75 13.5Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9H19.5V3H4.5V9ZM19.5 10.5H4.5C3.67275 10.5 3 9.82725 3 9V3C3 2.17275 3.67275 1.5 4.5 1.5H19.5C20.3272 1.5 21 2.17275 21 3V9C21 9.82725 20.3272 10.5 19.5 10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentHiring);
export default __webpack_public_path__ + "static/media/recent-hiring.68579636333a2abc2c1a1ff9a4119052.svg";
export { ForwardRef as ReactComponent };